export default [    //群组
  {
    path: "/groupList",   //群组列表
    name: 'groupList',
    component: () => import("@/views/group/groupList.vue")
  },
  {
    path: "/groupDetail",   //群组详情
    name: 'groupDetail',
    component: () => import("@/views/group/groupDetail.vue")
  },
  {
    path: "/groupAdd",   //创建群组
    name: 'groupAdd',
    component: () => import("@/views/group/groupAdd.vue")
  },
  {
    path: "/groupMembers",   //群组成员
    name: 'groupMembers',
    component: () => import("@/views/group/groupMembers.vue")
  },
  {
    path: "/unMembers",   //选择要添加的成员
    name: 'unMembers',
    component: () => import("@/views/group/unMembers.vue")
  },
  {
    path: "/groupChoice",   //选择要添加的成员
    name: 'groupChoice',
    component: () => import("@/views/group/groupChoice.vue")
  },
  {
    path: "/compereAdd",   //群组主持人
    name: 'compereAdd',
    component: () => import("@/views/group/compereAdd.vue")
  },
  {
    path: "/ListeningGroup",   //监听群组
    name: 'ListeningGroup',
    component: () => import("@/views/group/ListeningGroup.vue")
  },
  {
    path: "/ListeningGroupAdd",   //添加监听群组
    name: 'ListeningGroupAdd',
    component: () => import("@/views/group/ListeningGroupAdd.vue")
  }
]
